exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .avatar[data-v-3c23521c]{width:40px;height:40px;border-radius:50%;vertical-align:middle;-o-object-fit:cover;object-fit:cover}table tbody td.username span.el-tag[data-v-3c23521c]{float:right}.pay[data-v-3c23521c]{padding:0 5px}.pay li[data-v-3c23521c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.pay li *[data-v-3c23521c]:nth-child(2){font-weight:bold}.increase[data-v-3c23521c]{color:#0abb87}", ""]);

// exports
